'use client';

import { c as _c } from "react/compiler-runtime";
import { Button, Tooltip } from '@common/components';
import { SvgTrash } from '@common/icon';
import { cn } from '@core/utils';
import { ADDITIONAL_BENEFIT_AMOUNT } from '../../_constants';
import type { OptionChangeParams } from '../../_types';
import { CartCount } from './CartCount';
export interface CartItemOptionProps {
  item: {
    optionName: string;
    extraPrice: number;
    quantity: number;
    soldOutYN?: boolean;
  };
  onChangeOption: (changes: OptionChangeParams) => void;
  onDelete: () => void;
  className?: string;
  showBenefitTooltip?: boolean;
}
export const CartItemOption = t0 => {
  const $ = _c(37);
  const {
    item,
    onChangeOption,
    onDelete,
    className,
    showBenefitTooltip: t1
  } = t0;
  const showBenefitTooltip = t1 === undefined ? false : t1;
  let t2;
  if ($[0] !== onChangeOption) {
    t2 = newQuantity => {
      onChangeOption({
        quantity: newQuantity
      });
    };
    $[0] = onChangeOption;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const handleQuantityChange = t2;
  let t3;
  if ($[2] !== onChangeOption) {
    t3 = () => {
      onChangeOption({
        optionItemIds: []
      });
    };
    $[2] = onChangeOption;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const handleEditOption = t3;
  const isSoldOut = item.soldOutYN ?? false;
  let t4;
  if ($[4] !== className) {
    t4 = cn("rounded-small bg-Gray-25 p-12", className);
    $[4] = className;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== isSoldOut) {
    t5 = cn("flex flex-1 flex-col gap-6", {
      "opacity-50": isSoldOut
    });
    $[6] = isSoldOut;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== item.extraPrice) {
    t6 = item.extraPrice > 0 && <span className="text-Gray-600">{" "}(+{item.extraPrice.toLocaleString()}원)</span>;
    $[8] = item.extraPrice;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== item.optionName || $[11] !== t6) {
    t7 = <p className="font-400 text-Gray-800 typo-body4 mobile-tablet:typo-caption1">{item.optionName}{t6}</p>;
    $[10] = item.optionName;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== isSoldOut) {
    t8 = isSoldOut && <span className="font-500 text-R-500 typo-caption2">품절</span>;
    $[13] = isSoldOut;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== t7 || $[16] !== t8) {
    t9 = <div className="flex items-center gap-4">{t7}{t8}</div>;
    $[15] = t7;
    $[16] = t8;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== handleEditOption || $[19] !== isSoldOut) {
    t10 = <div className="w-fit"><Button dimensions="H32" theme="sub-line" className="shrink-0 bg-Gray-white text-Gray-900 mobile-tablet:h-26 mobile-tablet:px-8 mobile-tablet:typo-caption2" onClick={handleEditOption} disabled={isSoldOut}>옵션 변경</Button></div>;
    $[18] = handleEditOption;
    $[19] = isSoldOut;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== t10 || $[22] !== t5 || $[23] !== t9) {
    t11 = <div className={t5}>{t9}{t10}</div>;
    $[21] = t10;
    $[22] = t5;
    $[23] = t9;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  let t12;
  if ($[25] !== handleQuantityChange || $[26] !== isSoldOut || $[27] !== item.quantity || $[28] !== onDelete || $[29] !== showBenefitTooltip) {
    t12 = isSoldOut ? <div className="flex h-26 items-center justify-center rounded-xsmall border border-Gray-400 bg-Gray-white px-8"><button type="button" onClick={onDelete} aria-label={"\uC0AD\uC81C"} className="size-12 text-Gray-600"><SvgTrash className="size-12" /></button></div> : <Tooltip open={showBenefitTooltip} side="bottom" align="start" isArrow={true} asChild={true} label={<span className="font-400 typo-caption1"><span className="text-O-400">{ADDITIONAL_BENEFIT_AMOUNT.toLocaleString()}원 추가 혜택</span>→ <span className="font-600">답례품 1개 추가</span></span>}><div className="w-fit"><CartCount count={item.quantity} onCountChange={handleQuantityChange} onDelete={onDelete} /></div></Tooltip>;
    $[25] = handleQuantityChange;
    $[26] = isSoldOut;
    $[27] = item.quantity;
    $[28] = onDelete;
    $[29] = showBenefitTooltip;
    $[30] = t12;
  } else {
    t12 = $[30];
  }
  let t13;
  if ($[31] !== t11 || $[32] !== t12) {
    t13 = <div className="flex items-start gap-10">{t11}{t12}</div>;
    $[31] = t11;
    $[32] = t12;
    $[33] = t13;
  } else {
    t13 = $[33];
  }
  let t14;
  if ($[34] !== t13 || $[35] !== t4) {
    t14 = <div className={t4}>{t13}</div>;
    $[34] = t13;
    $[35] = t4;
    $[36] = t14;
  } else {
    t14 = $[36];
  }
  return t14;
};